import { attribute, attributeAsInt } from "../../../utils";

export function getBasketItemAttributes(element: Element): BasketItemInfo {
  if (element.hasAttribute("data-basket")) {
    const removalData = attribute(element, "data-basket");
    const basketInfo: BasketItemInfo = JSON.parse(removalData);
    return basketInfo;
  }

  const eventId = attributeAsInt(element, "data-event-id");
  const productId = attributeAsInt(element, "data-product-id");
  const areaId = attributeAsInt(element, "data-area-id");
  return [null, eventId, productId, areaId];
}

export type BasketItemInfo = [eventPageId: number | undefined, eventId: number, productId: number, areaId: number];
